import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
  Button,
  InputGroup,
  FormControl,
  FormLabel,
  Input,
  FormErrorMessage,
  InputLeftAddon,
  Flex
} from '@chakra-ui/react';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { z } from 'zod';
import { api } from '../../../../../services/api';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import { ListTags } from './ListTags';
//import reactselect
import Select from 'react-select';
import { useEffect } from 'react';

const schemaRegisterTag = z.object({
  nomeTag: z.string().min(3, 'O nome deve conter no mínimo 3 caracteres'),
  linkTag: z
    .string()
    .min(5, 'O link deve conter no mínimo 5 caracteres')
    .transform((value) => {
      if (!value.startsWith('https://')) {
        return `https://${value}`;
      }
      return value;
    })
});

async function registerTagFn(data) {
  const response = await api.post('/site/v2/atualizacao-seo-categoria/atualiza-tag-segmento', data);

  return response.data;
}

async function getSegmentoSite() {
  const response = await api.get('/site/v2/segmento/listar');

  return response.data.sort((a, b) => a.descricao.localeCompare(b.descricao));
}

async function getTituloSeoSegmento(segmento) {
  try {
    const response = await api.get(
      `/site/v2/atualizacao-seo-categoria/listar-titulo-segmento/${segmento}`
    );

    return {
      tituloSegmento: response.data[0].titulo_segmento,
      descricaoSegmento: response.data[0].descricao_segmento,
      tags_segmento: response.data[0].tags_segmento
    };
  } catch (err) {
    console.log(err);
    return {
      tituloSegmento: '',
      descricaoSegmento: '',
      tags_segmento: []
    };
  }
}

export function TagSegmento() {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
    watch,
    setValue,
    resetField
  } = useForm({
    resolver: zodResolver(schemaRegisterTag)
  });

  const queryClient = useQueryClient();

  const { mutateAsync: registerTag, isLoading } = useMutation({
    mutationFn: registerTagFn,
    onSuccess: () => {
      queryClient.invalidateQueries('registeredSegmento');

      resetField('nomeTag');
      resetField('linkTag');
    },
    onError: (err) => {
      console.log(err);
    }
  });

  const { data: segmentos } = useQuery({
    queryKey: 'segmentos',
    queryFn: getSegmentoSite,
    refetchOnWindowFocus: false,
    staleTime: 1000 * 60 * 60 * 24
  });

  async function onSubmit(data) {
    const params = {
      tag: data.nomeTag,
      link_tag: data.linkTag,
      codigo_segmento: String(watch('segmento'))
    };

    await registerTag(params);
  }

  const codigoSegmento = watch('segmento');

  const { data: registeredSegmento = [] } = useQuery({
    queryKey: ['registeredSegmento', codigoSegmento],
    queryFn: () => getTituloSeoSegmento(codigoSegmento),
    refetchOnWindowFocus: false,
    enabled: !!codigoSegmento
  });

  useEffect(() => {
    if (!isOpen) {
      setValue('segmento', '');
    }
  }, [isOpen, setValue]);

  console.log('registeredSegmento', registeredSegmento);

  return (
    <>
      <Button size="md" my={2} colorScheme="blue" onClick={onOpen}>
        Cadastrar nova Tag para Segmento
      </Button>

      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Cadastrar nova Tag para Segmento</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Select
              styles={{
                control: (baseStyles, state) => ({
                  ...baseStyles,
                  borderColor: state.isFocused ? 'blue.300' : 'gray.200',
                  fontSize: '14px',
                  height: '32px'
                })
              }}
              options={segmentos?.map((categoria) => ({
                value: categoria.codigo_segmento,
                label: categoria.descricao
              }))}
              placeholder="Selecione um segmento"
              onChange={(value) => setValue('segmento', value.value)}
            />

            <form onSubmit={handleSubmit(onSubmit)}>
              <fieldset
                disabled={!codigoSegmento}
                style={{
                  opacity: codigoSegmento ? 1 : 0.5,
                  cursor: codigoSegmento ? 'auto' : 'not-allowed'
                }}
                c>
                <FormControl isInvalid={errors.nomeTag} mt={2}>
                  <FormLabel htmlFor="nomeTag">Nome da Tag</FormLabel>
                  <Input size="sm" id="nomeTag" placeholder="nomeTag" {...register('nomeTag')} />
                  <FormErrorMessage>{errors.nomeTag && errors.nomeTag.message}</FormErrorMessage>
                </FormControl>
                <FormControl mt={2} isInvalid={errors.linkTag}>
                  <FormLabel htmlFor="linkTag">Link da Tag</FormLabel>
                  <InputGroup size="sm">
                    <InputLeftAddon>https://</InputLeftAddon>
                    <Input id="linkTag" placeholder="linkTag" {...register('linkTag')} />
                  </InputGroup>
                  <FormErrorMessage>{errors.linkTag && errors.linkTag.message}</FormErrorMessage>
                </FormControl>
                <Flex
                  mt={4}
                  justifyContent="flex-end"
                  alignItems="center"
                  flexDirection="row"
                  gap={2}>
                  <Button mt={4} colorScheme="blue" isLoading={isSubmitting} type="submit">
                    Confirmar
                  </Button>
                  <Button mt={4} ml={2} colorScheme="red" onClick={onClose}>
                    Cancelar
                  </Button>
                </Flex>
              </fieldset>
            </form>

            <ListTags listTags={registeredSegmento?.tags_segmento} />
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
}
